// src/data/blogPosts.js
// Local cover images live in /public/images. If cover.src is "", use cover.local.

export const blogPosts = [
  {
    id: "medicare-101-getting-started",
    slug: "medicare-101-getting-started",
    title: "Medicare 101: Getting Started the Right Way",
    excerpt:
      "Turning 65 or new to Medicare? This guide explains Parts A, B, C, and D in plain English—plus what to do next.",
    content: `
<p>Starting Medicare doesn't have to be confusing. Here's the simple flow:</p>
<ol>
  <li>Enroll in Original Medicare (Parts A & B) via Social Security.</li>
  <li>Decide whether you want a Medicare Advantage (Part C) plan or to stay on Original Medicare with a Medigap (Supplement) policy.</li>
  <li>If you take prescriptions, consider a Part D plan (or Advantage plan that includes Rx).</li>
</ol>
<h3>Key Windows</h3>
<ul>
  <li><strong>Initial Enrollment Period (IEP):</strong> 7 months around your 65th birthday.</li>
  <li><strong>Annual Enrollment Period (AEP):</strong> Oct 15 – Dec 7 each year.</li>
</ul>
<p>Questions? Our licensed team can provide personalized options based on your doctors, prescriptions, and budget.</p>
`,
    cover: {
      src: "/images/senior-reviewing.jpg", // keep blank so UI uses the local file
      local: "/images/medicare-101.jpg",
      alt: "Senior reviewing Medicare information at home",
      credit: "The Medicare Family",
    },
    author: "Your Choice Associates",
    date: "2025-07-31",
    readTime: 6,
    category: "Medicare Basics",
    tags: ["Medicare", "Enrollment", "Beginners"],
  },

  {
    id: "compare-medicare-advantage-vs-supplement",
    slug: "compare-medicare-advantage-vs-supplement",
    title: "Medicare Advantage vs. Supplement: How to Choose",
    excerpt:
      "We compare costs, networks, and flexibility so you can pick the path that fits your lifestyle.",
    content: `
<p>Both options can work great—it's about fit:</p>
<h3>Medicare Advantage (Part C)</h3>
<ul>
  <li>Often low premiums</li>
  <li>Provider networks (HMO/PPO)</li>
  <li>Extras: dental, vision, hearing, OTC</li>
</ul>
<h3>Medicare Supplement (Medigap)</h3>
<ul>
  <li>Higher premiums, fewer out-of-pocket surprises</li>
  <li>Use any doctor that accepts Medicare</li>
  <li>Pair with standalone Part D for prescriptions</li>
</ul>
<p>Tip: List your doctors and meds first; the “right” answer usually reveals itself from there.</p>
`,
    cover: {
      src: "", // blank => use local
      local: "/images/advantage-vs-supplement.jpg",
      alt: "Healthcare team discussing Medicare plan options",
      credit: "Unsplash / National Cancer Institute",
    },
    author: "Your Choice Associates",
    date: "2025-07-27",
    readTime: 7,
    category: "Plan Comparisons",
    tags: ["Advantage", "Medigap", "Costs"],
  },

  {
    id: "lower-rx-costs-part-d-tips",
    slug: "lower-rx-costs-part-d-tips",
    title: "Lower Your Rx Costs: Smart Part D Tips",
    excerpt:
      "Formularies, tiers, preferred pharmacies—here’s how to avoid overpaying for medications.",
    content: `
<p>Check these items annually:</p>
<ul>
  <li>Are your meds on the plan formulary? Any tier changes?</li>
  <li>Does the plan have preferred pharmacy pricing?</li>
  <li>Mail order vs. retail: which is cheaper this year?</li>
</ul>
<p>Bring your list of prescriptions to us, and we’ll match plans to real costs, not guesses.</p>
`,
    cover: {
      src: "", // blank => use local
      local: "/images/rx-costs.jpg",
      alt: "Prescription medicine bottles and calculator",
      credit: "Unsplash / Towfiqu barbhuiya",
    },
    author: "Your Choice Associates",
    date: "2025-07-21",
    readTime: 5,
    category: "Prescription Drug Coverage",
    tags: ["Part D", "Pharmacy", "Savings"],
  },

  {
    id: "life-insurance-basics-term-vs-permanent",
    slug: "life-insurance-basics-term-vs-permanent",
    title: "Life Insurance Basics: Term vs. Permanent",
    excerpt:
      "A quick framework to decide coverage amount, term length, and when permanent policies make sense.",
    content: `
<p>Start with the purpose: income replacement, legacy, or final expenses?</p>
<ul>
  <li><strong>Term:</strong> Most affordable for a set period (10–30 years).</li>
  <li><strong>Permanent:</strong> Lifelong coverage with potential cash value.</li>
</ul>
<p>We can help you model the right coverage for your goals and budget.</p>
`,
    cover: {
      src: "", // use your local image instead of a remote URL to avoid CORS/fallback issues
      local: "/images/calculator.avif",
      alt: "Financial planning with calculator and documents",
      credit: "Unsplash / Kelly Sikkema",
    },
    author: "Your Choice Associates",
    date: "2025-07-14",
    readTime: 5,
    category: "Life Insurance",
    tags: ["Term Life", "Permanent Life", "Planning"],
  },
];

// Helpers for filters
export const allCategories = [
  "All",
  ...Array.from(new Set(blogPosts.map((p) => p.category))),
];

export const allTags = Array.from(
  new Set(blogPosts.flatMap((p) => p.tags))
).sort();
